import React, { createContext, useCallback, useMemo, useState } from "react";

const MenuContext = createContext(null);
export default MenuContext;

export const MenuProvider = ({ children }) => {
  const [menuIsOpen, setMenuIsOpen] = useState(false);

  const toggleMenu = useCallback(() => {
    setMenuIsOpen((prev) => !prev);
  }, []);

  const closeMenu = useCallback(() => {
    setMenuIsOpen(false);
  }, []);

  const openMenu = useCallback(() => {
    setMenuIsOpen(true);
  }, []);

  const value = useMemo(
    () => ({
      menuIsOpen,
      toggleMenu,
      closeMenu,
      openMenu,
    }),
    [menuIsOpen, toggleMenu, closeMenu, openMenu]
  );

  return (
    <MenuContext.Provider value={value}>{children}</MenuContext.Provider>
  );
};
